'use client'

import React from 'react'
import { useRouter } from 'next/navigation'
import { motion } from 'framer-motion'
import { setLocalUser } from '@/lib/actions/auth/set-local-user'
import { setLocalRegister } from '@/lib/actions/register/set-local-register'
import { cn } from '@/lib/utils'

import { AvatarCard, AvatarCardSkeleton } from '@/components/ui/avatar-card'

interface UserCardListProps extends React.ComponentPropsWithoutRef<'div'> {
  list: any[]
  branch: string
}

const variants = {
  animate: {
    opacity: 1,
    marginTop: 0,
    transition: {
      staggerChildren: 0.1,
    },
  },
}

export const UserCardList = ({
  list,
  branch,
  className,
}: UserCardListProps) => {
  const router = useRouter()
  const [isLoading, setIsLoading] = React.useState(false)

  return (
    <motion.div
      variants={variants}
      animate="animate"
      className={cn('p-1', className)}
    >
      {(list || [])?.map((user) => {
        return (
          <AvatarCard
            actionLabel="Select"
            className="mt-2 cursor-pointer opacity-0"
            key={user?.id}
            label={user?.name}
            shortCode={user?.code?.substring(0, 2)}
            variants={variants}
            isLoading={isLoading === user?.id}
            disabled={isLoading}
            onClick={async () => {
              setIsLoading(user?.id)
              await setLocalUser(user)
              router.push(`/onboard/${branch}/pin/${user?.id}`)
            }}
          />
        )
      })}
    </motion.div>
  )
}

export const UserCardListSkeleton = () => {
  return (
    <motion.div
      variants={variants}
      animate="animate"
      className="flex w-full flex-col gap-2 py-8 opacity-100 md:px-4"
    >
      <AvatarCardSkeleton variants={variants} className="opacity-100" />
      <AvatarCardSkeleton variants={variants} className="opacity-100" />
      <AvatarCardSkeleton variants={variants} className="opacity-100" />
    </motion.div>
  )
}
